// Quick-pick credit amounts shared by the wallet Top Up dialog and the
// onboarding Initial-credits fields (Indian notation: 1L = 1,00,000).
// Free-typed amounts stay supported via the freeSolo Autocomplete.
export const CREDIT_PRESETS = [
  {label: '10k', value: '10000'},
  {label: '25k', value: '25000'},
  {label: '50k', value: '50000'},
  {label: '1L', value: '100000'},
  {label: '5L', value: '500000'}
];
